import { ThemeProvider } from "@mui/material/styles";
import { closeSnackbar, SnackbarProvider } from "notistack";
import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { RecoilRoot } from "recoil";

import AppErrorBoundary from "./components/Atoms/ErrorBoundary";
import { DoingOverlay } from "./components/Organisms/DoingOverlay";
import { AiOfferPendingProvider } from "./providers/AiOfferPendingProvider";
import { AuthProvider } from "./providers/AuthProvider";
import { UnreadMatchingProvider } from "./providers/UnreadMatchingProvider";
import { routerPaths } from "./routes";
import { theme } from "./theme";

const App: React.FC = () => {
  return (
    <AppErrorBoundary>
      <ThemeProvider theme={theme}>
        <SnackbarProvider
          maxSnack={3}
          SnackbarProps={{
            onClick: () => closeSnackbar(),
            style: { cursor: "pointer" },
          }}
        >
          <RecoilRoot>
            <BrowserRouter>
              <AuthProvider>
                <UnreadMatchingProvider>
                  <AiOfferPendingProvider>
                    <Suspense fallback={<DoingOverlay open={true} />}>
                      <Routes>
                        {/* <Route index element={<Home />} /> */}
                        {routerPaths.map((routerPath) => (
                          <Route key={routerPath.path} path={routerPath.path} element={routerPath.element}>
                            {routerPath.children?.map((child) => (
                              <Route key={child.path} path={child.path} element={child.element} />
                            ))}
                          </Route>
                        ))}
                      </Routes>
                    </Suspense>
                  </AiOfferPendingProvider>
                </UnreadMatchingProvider>
              </AuthProvider>
            </BrowserRouter>
          </RecoilRoot>
        </SnackbarProvider>
      </ThemeProvider>
    </AppErrorBoundary>
  );
};

export default App;
